import type { ReactNode } from 'react';

import styles from './Pill.module.css';

export type PillTone = 'neutral' | 'ok' | 'warn' | 'danger' | 'info';

export interface PillProps {
  children: ReactNode;
  tone?: PillTone;
  variant?: 'soft' | 'solid';
  showDot?: boolean;
  className?: string;
  /** Подсказка при наведении: в пилюлю влезает не всё. */
  title?: string;
}

export function Pill({
  children,
  tone = 'neutral',
  variant = 'soft',
  showDot,
  className,
  title,
}: PillProps) {
  const toneText =
    tone === 'ok'
      ? styles.textOk
      : tone === 'warn'
        ? styles.textWarn
        : tone === 'danger'
          ? styles.textDanger
          : tone === 'info'
            ? styles.textInfo
            : null;

  const cls = [
    styles.pill,
    variant === 'solid' ? styles.solid : styles.soft,
    !showDot && variant !== 'solid' && toneText,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const dotCls = [
    styles.dot,
    tone === 'ok' && styles.ok,
    tone === 'warn' && styles.warn,
    tone === 'danger' && styles.danger,
    tone === 'info' && styles.info,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={cls} title={title}>
      {showDot && <span className={dotCls} />}
      {children}
    </span>
  );
}
